<template>
  <div>
    <div class="cardList">
      <Header title="我的油卡" />
      <!-- <LoadingModal /> -->
      <div class="pageBottom list">
        <template v-for="(item, index) in cardList">
          <div class="pageBigRadius listItem" :key="index">
            <img :src="item.cardType === 0 ? shIcon : syIcon" />
            <p>账户名：{{ item.cardHolder }}</p>
            <p class="cardNum">
              {{ item.cardNum.replace(/(.{4})/g, "$1 ") }}
            </p>
            <div class="line"></div>
            <div class="footer">
              <div class="left" @click="handleDefault(index)">
                <div>
                  <van-checkbox :value="item.cardIsDefault == 1 ? true : false">
                    <span style="color: var(--depYelColor)">默认</span>
                    <i
                      slot="icon"
                      slot-scope="props"
                      class="iconfont"
                      :class="props.checked ? activeIcon : inactiveIcon"
                    />
                  </van-checkbox>
                </div>
              </div>
              <div class="right">
                <div class="cell" @click="handleEdit(index)">
                  <i class="iconfont iconedit"></i>
                  <span>编辑</span>
                </div>
                <div class="cell" @click="handleDel(index)">
                  <i class="iconfont icondelete"></i>
                  <span>删除</span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 添加油卡 -->
        <router-link
          tag="div"
          class="pageBigRadius listItem addCard"
          to="/addCard"
        >
          <i class="iconfont iconadd-s" />
          <span>添加油卡</span>
        </router-link>
      </div>
    </div>
    <!-- <Tips class="pageFooterPage">
      <ul>
        <li>本平台加油卡充值仅支持中石化、中石油卡充值</li>
        <li>充值开放时间为法定工作日8:30～17:30，预计到账时间为提交订单后3个工作日内</li>
        <li>
          服务热线：
          <a href="tel:400-8812-336">400-8812-336(8:30 ~ 17:30)</a>
        </li>
      </ul>
    </Tips>-->
  </div>
</template>

<script>
import { getOilCardList, setDelCard } from "api/onLine";
import { deleteOilCard,setOilCard } from "api/submit";
export default {
  components: {},
  data() {
    return {
      serveId: "",
      cardList: [],
      shIcon: require("assets/sh.png"),
      syIcon: require("assets/sy.png"),
      // 多选
      checked: false,
      activeIcon: "iconradioschecked",
      inactiveIcon: "iconradiosnormal",
      count: 0,
    };
  },
  mounted() {
    this.serveId = this.$route.query.serve_id;
    this.getCardList();
  },
  created() {
    this.handleDefault = this.$debounce(this.handleDefault);
  },
  methods: {
    getCardList() {
      getOilCardList().then((res) => {
        if (res.status == 200) {
          this.count = res.data.length;
          this.cardList = res.data;
        } else {
          this.$error(res.message);
        }
      });
    },
    handleDefault(index) {
      setOilCard(this.cardList[index].cardId, 1).then((res) => {
        if (res.status == 200) {
          this.$successSync("更换成功", () => {
            this.$back(-1);
          });
        } else {
          this.$error(res.message);
        }
      });
    },
    handleEdit(index) {
      this.$push({
        name: "UpdateCard",
        query: {
          cardId: this.cardList[index].cardId,
          type: this.cardList[index].cardType,
          cardNumber: this.cardList[index].cardNum,
          userName: this.cardList[index].cardHolder,
          phone: this.cardList[index].cardMobile,
        },
      });
    },
    handleDel(index) {
      if(this.cardList[index].cardIsDefault==1){
         this.$error("不能删除默认油卡");
         return;
      }
      //删除
      this.$confirm("确定删除此油卡吗？").then(() => {
        deleteOilCard(this.cardList[index].cardId).then((res) => {
          if (res.status == 200) {
            this.$successSync("删除成功", () => {
              this.getCardList();
            });
          } else {
            this.$error(res.message);
          }
        });
      });
    },
  },
};
</script>

<style scoped lang="less">
.cardList {
  width: 92%;
  margin: 0px 15px;
  .listItem {
    background: var(--activeColor);
    border: 2px solid;

    color: var(--depYelColor);
    font-size: 14px;
    padding: 10px;
    margin-top: 15px;
    box-sizing: border-box;
    position: relative;
    p {
      text-align: center;
      margin: 10px 0;
    }
    .cardNum {
      font-size: 20px;
    }
    img {
      position: absolute;
      left: 10px;
      top: 10px;
      width: 30px;
      height: 30px;
    }
    .line {
      height: 1px;
      border-top: 1px dashed #eee;
    }
    .footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 35px;
      .van-checkbox__label {
        color: inherit;
      }
      .left {
        span {
          display: inline-block;
          margin-top: 5px;
        }
      }
      .right {
        font-size: 12px;
        width: 34%;
        display: flex;
        justify-content: flex-end;
        .cell {
          margin-left: 8px;
        }
        i {
          font-size: 10px;
          margin-right: 2px;
        }
      }
    }
  }
  .listItem:first-child {
    margin-top: 5px;
  }
  .addCard {
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      margin-left: 5px;
    }
  }
}
</style>
